module.exports = __webpack_public_path__ + "static/img/176043689add7ce4db22d7e0b232011f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon2.jpg
// module id = UzAa
// module chunks = 1